import { Component, OnInit } from '@angular/core';
import {DoctorsService} from '../../services/doctors/doctors.service';
import {SpecialitesService} from '../../services/specialites/specialites.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-medici-list',
  templateUrl: './medici-list.component.html',
  styleUrls: ['./medici-list.component.scss']
})
export class MediciListComponent implements OnInit {
    specialties: any;
    doctors: any;
    endpoint: any;

  constructor(
      private doctorsService: DoctorsService,
      private specialtiesService: SpecialitesService
  ) {
      const t = this;
      t.endpoint = environment.endpoint;
      this.loadItems();
      this.loadSpecs();
  }

  ngOnInit(): void {
  }

    loadItems() {
        const t = this;
        this.doctorsService.get().subscribe((data: any) => {
            t.doctors = data;
            var test = [];
            for (let index = 0; index < t.doctors.length; index++) {
              if(t.doctors[index].medicalStaffType != null){
                test.push(t.doctors[index]);
              }

            }
            t.doctors = test;
        });
    }

    loadSpecs() {
      const t = this;
      this.specialtiesService.get().subscribe((data: any) => {
          t.specialties = data;


          for (let i = 0; i < t.specialties.length; i++) {
            let  test = [];
            for (let index = 0; index < t.specialties[i].doctors.length; index++) {

                if(t.specialties[i].doctors[index].medicalStaffType != null){
                    test.push(t.specialties[i].doctors[index]);
                }


              }
              t.specialties[i].doctors = test;
          }


      });
    }

    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }

}
